// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SrPQh","cell":"styles_cell__2YTQi"};